import React, { useState, useEffect } from 'react';
import html2canvas from 'html2canvas';
import { dateFormatConDiaYHoraShort, getDate } from '../../utils/DateFunctions'
import jsPDF from 'jspdf';

const EjecucionSiembraPDF = (p) => {
    const width = 1100;
    const height = width * 1.294117647058824;
    const dias_m = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const docs_by_page = 60;
    const [reporte, setreporte] = useState([]);

    useEffect(() => {
        make_report();
    }, []);

    const make_report = () => {
        let reps = [];
        let hoja = [];

        let data = [...(p.data ?? [])]

        for (let i = 0; i < data.length; i++) {
            let dt = data[i];
            let insert = {
                'bloque': `${dt.flor} ${dt.variedad} ${dt.color}`,
                'plan_plantas': dt.plantas,
                'plan_charolas': dt.charolas,
                'semana': dt.semanainicio,
                'semilla': dt.semilla_disponible === "SI" ? true : false,
                'rendimiento': dt.unidad_hora && dt.unidad_hora > 0 ? dt.unidad_hora : false,
                'plan': [],
                'ejecutado': [],
                'horas': []
            };
            let total_plan = 0, total_ejecutado = 0, total_horas = 0;
            for (let j = 0; j < dias.length; j++) {
                let plan = dias[j] + "_plan";
                let ejecutado = dias[j] + "_ejecutado";
                total_ejecutado += dt[ejecutado];
                total_plan += dt[plan];
                total_horas += insert.rendimiento ? +(dt[plan] / insert.rendimiento).toFixed(1) : 0;
                insert.plan.push(dt[plan]);
                insert.ejecutado.push(dt[ejecutado]);
                insert.horas.push(insert.rendimiento ? +(dt[plan] / insert.rendimiento).toFixed(1) : 0);
            }
            insert.tp = total_plan;
            insert.te = total_ejecutado;
            insert.th = total_horas;
            if (hoja.length < docs_by_page) hoja.push(insert);
            else {
                reps.push([...hoja]);
                hoja = [];
            }
        }

        if (hoja.length > 0) reps.push(hoja);
        console.log(reps);
        setreporte(reps);
    }

    const createPDF = async () => {
        console.log('data', p.data);
        if (p.data.length === 0) return;
        p.loader(true);
        const doc = new jsPDF({
            orientation: 'portrait', // 'portrait' para retrato, 'landscape' para apaisado
            unit: 'mm',
            format: [215.9, 279.4], // [ancho, alto]
        });

        for (let i = 0; i < reporte.length; i++) {
            let id = "hojaArr" + i;
            const componentRef = document.getElementById(id); // Reemplaza con el ID de tu componente

            if (componentRef) {
                const canvas = await html2canvas(componentRef, { scale: 1.5 });
                const imgData = canvas.toDataURL('image/png');

                // Calcula el ancho y el alto de la imagen en el PDF
                const imgWidth = 215.9; // Ancho de la página en mm (A4)
                const imgHeight = 279.4;

                // Agrega la imagen como una nueva página al PDF
                if (i > 0) {
                    doc.addPage();
                }
                doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            }
        }

        // Guarda el PDF como un solo archivo
        doc.save('REP_EJEC_PLAN_' + p.data[0].semanainicio);
        p.loader(false);
    };

    const columnaTotales = (json) => {
        let planeado = 0;
        let ejecutado = 0;
        let horas = 0;
        for (let i = 0; i < 6; i++) {
            planeado += json.plan[i];
            ejecutado += json.ejecutado[i];
            horas += json.horas[i];
        }
        return (
            <div className={`text-center text-bold border-start border-dark p-0 m-0`} style={{ width: `${80 / 7}%` }}>
                {json.semilla && json.rendimiento && <div className='row justify-content-evenly w-100 m-0 p-0 '>
                    <div className='w-45 text-center m-0 p-0 border-end'>{planeado}</div>
                    <div className='w-30 text-center m-0 p-0 border-end'>{+horas.toFixed(1)}</div>
                    <div className='w-25 text-center m-0 p-0'>{+(horas / 8).toFixed(1)}</div>
                </div>}
                {json.semilla && !json.rendimiento && <div className='w-100 text-s contenedor'>✖ Sin rendimiento</div>}
                {!json.semilla && <div className='w-100 text-s contenedor'>❌ Sin semillas</div>}
            </div>
        );
    }

    return (
        <div className='col-lg-12 p-0 m-0' key={"rtqfqweryeq4w"}>
            <div className='row justify-content-evenly m-0 p-0 w-100 mt-5' style={{ position: "sticky", top: 0, zIndex: 2 }}>
                <div className='col-auto  text-center'>
                    <button className='btn btn-danger mt-2 shadow ps-5 pe-5 round-xxl' onClick={p?.close ?? (() => { })} >Cerrar</button>
                </div>
                <div className='col-auto mt-2 text-center'>
                    <button className='btn btn-warning shadow round-xxl scale-continue-05 text-bold ps-5 pe-5' onClick={createPDF} >Descargar {reporte.length} hoja(s)</button>
                </div>
                <div className='w-100 m-0 p-0'></div>
                {reporte.map((hoja, k) =>
                    <div key={"hoja aaa" + k} id={"hojaArr" + k} className={'bg-white text-center mt-5 mb-5 p-3 dosis' + (hoja.length === docs_by_page ? " contenedor" : "")}
                        style={{ minWidth: width, maxWidth: width, minHeight: height, maxHeight: height, border: "black solid 2px" }}>
                        <div className='row justify-content-evenly m-0 p-0 w-100'>
                            <div className='col-lg-12 text-end text-s text-300 p-0 m-0'>
                                <span className='me-2 text-bold'>Reporte de ejecución de siembra</span>
                                Fecha de creación:{dateFormatConDiaYHoraShort(getDate())}
                            </div>
                            <div className='w-100 m-0 p-0 mt-3' />
                            <div className='text-l text-bold border-bottom border-dark contenedor' style={{ width: '20%' }}>BLOQUE</div>
                            {dias_m.map((val, kl) =>
                                <div key={kl + val} className='text-center text-bold border-start border-bottom border-dark p-0 m-0' style={{ width: `${80 / 7}%` }}>
                                    {val}
                                    <div className='w-100' />
                                    <div className='row justify-content-evenly w-100 m-0 p-0 text-300'>
                                        <div className='w-45 p-0 m-0 border-end text-s'>Planeado</div>
                                        <div className='w-30 p-0 m-0 border-end text-s'>Hrs</div>
                                        <div className='w-25 p-0 m-0 text-s'>Pers</div>
                                    </div>

                                </div>
                            )}
                            <div className='text-center text-bold border-start border-bottom border-dark p-0 m-0' style={{ width: `${80 / 7}%` }}>
                                TOTALES
                                <div className='w-100' />
                                <div className='row justify-content-evenly w-100 m-0 p-0 text-300'>
                                    <div className='w-45 p-0 m-0 border-end text-s'>Planeado</div>
                                    <div className='w-30 p-0 m-0 border-end text-s'>Hrs</div>
                                    <div className='w-25 p-0 m-0 text-s'>Pers</div>
                                </div>

                            </div>

                            {hoja.map((json, i) =>
                                <div key={k + json.bloque + i} className={'w-100 m-0 p-0 p-0 ' + (i < (docs_by_page - 1) ? "border-bottom border-dark" : "")}>
                                    <div className='row justify-content-evenly m-0 p-0 w-100'>

                                        <div className='m-0 p-0 text-start text-s text-bold' style={{ width: '20%' }}>
                                            <span className='text-xs text-500 me-1'>{json.semana}</span>{json.bloque}
                                        </div>
                                        {
                                            json.plan.map((val, j) =>
                                                <div className={`text-center border-start border-dark p-0 m-0`} key={j + val + i + json.bloque + k} style={{ width: `${80 / 7}%` }}>
                                                    {json.semilla && json.rendimiento && <div className='row justify-content-evenly w-100 m-0 p-0 '>
                                                        <div className='w-45 text-center m-0 p-0 border-end'>{val}</div>
                                                        <div className='w-30 text-center m-0 p-0 border-end'>{json.horas[j]}</div>
                                                        <div className='w-25 text-center m-0 p-0'>{+(json.horas[j] / 8).toFixed(1)}</div>
                                                    </div>}
                                                    {!json.rendimiento && json.semilla && <div className='w-100 text-s contenedor'>✖ Sin rendimiento</div>}
                                                    {!json.semilla && <div className='w-100 text-s contenedor'>❌ Sin semillas</div>}
                                                </div>
                                            )
                                        }
                                        {columnaTotales(json)}
                                    </div>
                                </div>
                            )
                            }
                        </div>
                    </div>)
                }
            </div >
        </div >
    )
}

export default EjecucionSiembraPDF;